import React from 'react';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import banner from '../../../../Assets/Linkages/SpaceOutreachFilm/Space-Outreach-Film-Banner.png';
import '../../../../Styles/Linkages&Outreach.css';
import JahanAurBhiHain from './JahanAurBhiHain';
import FilmAtGlance from './FilmAtGlance';
import ResearchMeetsReel from './ResearchMeetsReel';
import TheTaleUnfolds from './TheTaleUnfolds';
import EchoesOfEarth from './EchoesOfEarth';
import CinemaAsCatalyst from './CinemaAsCatalyst';
import PremiereAtIST from './PremiereAtIST';
import WorldTelevisionPremiere from './WorldTelevisionPremiere';
import InternationalDebut2026 from './InternationalDebut2026';
import LahoreScienceMela2025 from './LahoreScienceMela2025';
import AudienceScreenings from './AudienceScreenings';
import FilmMediaCoverage from './FilmMediaCoverage';
import FilmSocialFeed from './FilmSocialFeed';

const SpaceOutreachFilm = () => (
  <>
    <AppHeader />
    <main className="space-outreach-film-page">
      <section className="outreach-event-hero" aria-label="Space Outreach Film">
        <img
          className="outreach-event-banner"
          src={banner}
          alt="Space Outreach Film"
        />
      </section>
      <JahanAurBhiHain />
      <FilmAtGlance />
      <ResearchMeetsReel />
      <TheTaleUnfolds />
      <EchoesOfEarth />
      <CinemaAsCatalyst />
      <PremiereAtIST />
      <WorldTelevisionPremiere />
      <InternationalDebut2026 />
      <LahoreScienceMela2025 />
      <AudienceScreenings />
      <FilmMediaCoverage />
      <FilmSocialFeed />
    </main>
    <FooterComponent />
  </>
);

export default SpaceOutreachFilm;
